import React from "react";
import { MainContainer, MainRow, MainCol } from "components/common";
import { CopyrighText, MainUl, Li } from "./footerElement";
const AdminFooter = () => {
  return (
    <div>
      <MainContainer>
        <MainRow>
          <MainCol>
            <CopyrighText style={{marginTop:"0.8rem"}}>© 2018-2022 Nethty </CopyrighText>
          </MainCol>
          <MainCol>
            <MainUl>
              <Li>Privacy Policy</Li>
              <Li>Terms of Services</Li>
            </MainUl>
          </MainCol>
        </MainRow>
      </MainContainer>
    </div>
  );
};

export default AdminFooter;
